import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=59f57b26"
import script from "./AssignmentList.vue?vue&type=script&lang=js"
export * from "./AssignmentList.vue?vue&type=script&lang=js"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=59f57b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports